<template>
  <w-modal
    :value="value"
    type="danger"
    width="448px"
    @close="onClose"
  >
    <h1 slot="header">關閉訪客訂購連結</h1>
    <div slot="content" class="content">
      <p>
        <span class="icon-alert-circle" /> 關閉訪客訂購連結後，訪客連結即自動失效，請確認是否關閉連結？
      </p>
    </div>
    <div slot="footer">
      <w-button
        :disabled="isDisablingLink"
        color-type="error"
        type="link"
        @click="onClose"
      >
        取消
      </w-button>
      <w-button
        :disabled="isDisablingLink"
        :loading="isDisablingLink"
        class="ml-2"
        color-type="error"
        @click="onDisableShareLink"
      >
        <span>關閉連結</span>
      </w-button>
    </div>
  </w-modal>
</template>

<script>
import DisableCustomLinkModal from './DisableCustomLinkModal';

export default DisableCustomLinkModal;
</script>
